import styled from 'styled-components';
var TypeformDiv = styled.div.withConfig({
  displayName: "Typeformstyles__TypeformDiv",
  componentId: "pantheon__atbvu9-0"
})(["padding:0;height:550px;width:100%;"]);
export { TypeformDiv };